/**
 * Created by mongoose on 25/04/16.
 */
import React from "react";

import CalendarSVG from "./svg/calendario.svg";
import AdultsSVG from "./svg/adultos.svg";
import ChildrenSVG from "./svg/ninos.svg";
import TeenagersSVG from "./svg/ninos.svg";
import BabiesSVG from "./svg/bebes.svg";
import RateSVG from "./svg/Tariff.svg";

import InfoSVG from "./svg/info.svg";
import InfoWhite from "./svg/infoWhite.svg";
import PromotionListSVG from "./svg/oferta.svg";
import ArrowDownSVG from "./svg/flecha2.svg";
import ArrowUpSVG from "./svg/arrowUP.svg";
import ArrowDownFillSVG from "./svg/flecha1.svg";
import ArrowLeftFillSVG from "./svg/flecha4.svg";
import LupaSVG from "./svg/lupa.svg";
import ShoppingCartSVG from "./svg/shopping_cart.svg";
import VistoSVG from "./svg/visto.svg";
import CerrarSVG from "./svg/cerrar.svg";
import AlertSVG from "./svg/alert_icon.svg";
import AddCircleSVG from "./svg/add_circle.svg";
import NavigateBeforeSVG from "./svg/navigate_before.svg";
import NavigateNextSVG from "./svg/navigate_next.svg";
import CarouselPrevSVG from "./svg/carousel_prev.svg";
import CarouselNextSVG from "./svg/carousel_next.svg";
import DeleteSVG from "./svg/delete.svg";
import NightSVG from "./svg/night.svg";

import ListViewSVG from "./svg/vista2.svg";
import MapViewSVG from "./svg/mapa.svg";
import RedesSVG from "./svg/redes.svg";
import ImprimirSVG from "./svg/imprimir.svg";
import DescargarSVG from "./svg/descargar.svg";
import PromoCodeSVG from "./svg/codigo.svg";
import LockSVG from "./svg/padlock.svg";
import SecuritySVG from "./svg/security.svg";
import CreditCardSVG from "./svg/credit_card.svg";

import ComodoSSLSVG from "./svg/comodossl.svg";
import PCIDSSSVG from "./svg/PCI_DSS.svg";
import ExitToAppSVG from "./svg/ic_exit_to_app_black_24px.svg";
import ViewListSVG from "./svg/ic_view_list_black_24px.svg";
import ListSVG from "./svg/list.svg";
import MapSVG from "./svg/ic_map_black_24px.svg";
import MarkerMapSVG from "./svg/pin_map.svg";

import ArrowBackSVG from "./svg/arrowBack.svg";
import ArrowForwardSVG from "./svg/arrowForward.svg";
import ArrowDropDownSVG from "./svg/arrowDropDown.svg";
import ArrowDropDownNoFillSVG from "./svg/arrowDropDownNoFill.svg";
import ArrowRightSVG from "./svg/arrowRight.svg";
import ArrowLeftSVG from "./svg/arrowLeft.svg";
import GPSNotFixedSVG from "./svg/gpsNotFixed.svg";
import DateRangeSVG from "./svg/dateRange.svg";
import PersonSVG from "./svg/person.svg";
import BabyCarriageSVG from "./svg/babyCarriage.svg";
import OccupantsSVG from "./svg/occupants.svg";
import MenuSVG from "./svg/menu.svg";
import ThumbUpSVG from "./svg/thumb_up.svg";
import RubishBinSVG from "./svg/rubbish_bin.svg";
import ErrorOutlineSVG from "./svg/error_outline.svg";
import WarningSVG from "./svg/warning.svg";

import OutlineInfoSVG from "./svg/outline-info.svg";
import Lock2SVG from "./svg/lock.svg";

import GiftSVG from "./svg/gift.svg";
import BaselineBarChartSVG from "./svg/baseline_bar_chart.svg";

import MoreVertSVG from "./svg/more_vert.svg";

import CloseSVG from "./svg/baseline-close-24px.svg";

import BuySVG from "./svg/buy.svg";

/* CREDIT CARD ICONS */
import VisaIcon from "./payments/visa-logo-xs.png";
import MasterCardIcon from "./payments/mastercard-logo-xs.png";
import AmexIcon from "./payments/amex-logo-xs.png";
import DiscoverIcon from "./payments/discover-logo-xs.png";
import JcbIcon from "./payments/jcb-logo-xs.png";
import DinersIcon from "./payments/diners-logo-xs.png";
import CarteBleuIcon from "./payments/carte-bleu-logo-xs.png";
import UnionPayIcon from "./payments/UnionPay.png";

export const creditCardIcons = {
  Visa: VisaIcon,
  MasterCard: MasterCardIcon,
  AmericanExpress: AmexIcon,
  Discover: DiscoverIcon,
  Jcb: JcbIcon,
  Diners: DinersIcon,
  CarteBleu: CarteBleuIcon,
  UnionPay: UnionPayIcon,
};
/* END CREDIT CARD ICONS */

export const SvgIcon = ({ src, ...props }) => (
  <span style={{ display: "inherit" }} {...props} dangerouslySetInnerHTML={{ __html: src }}></span>
);

export const CalendarIcon = props => <SvgIcon {...props} src={CalendarSVG} />;
export const Seniors = props => <SvgIcon {...props} src={AdultsSVG} />;
export const Adults = props => <SvgIcon {...props} src={AdultsSVG} />;
export const Children = props => <SvgIcon {...props} src={ChildrenSVG} />;
export const Teenagers = props => <SvgIcon {...props} src={TeenagersSVG} />;
export const Babies = props => <SvgIcon {...props} src={BabiesSVG} />;

export const InfoIcon = props => <SvgIcon {...props} src={InfoSVG} />;
export const InfoWhiteIcon = props => <SvgIcon {...props} src={InfoWhite} />;
export const PromotionListIcon = props => <SvgIcon {...props} src={PromotionListSVG} />;
export const ArrowDownIcon = props => <SvgIcon {...props} src={ArrowDownSVG} />;
export const ArrowUpIcon = props => <SvgIcon {...props} src={ArrowUpSVG} />;
export const ArrowDownFillIcon = props => <SvgIcon {...props} src={ArrowDownFillSVG} />;
export const ArrowLeftFillIcon = props => <SvgIcon {...props} src={ArrowLeftFillSVG} />;
export const LupaIcon = props => <SvgIcon {...props} src={LupaSVG} />;
export const ShoppingCartIcon = props => <SvgIcon {...props} src={ShoppingCartSVG} />;
export const VistoIcon = props => <SvgIcon {...props} src={VistoSVG} />;
export const CerrarIcon = props => <SvgIcon {...props} src={CerrarSVG} />;
export const AlertIcon = props => <SvgIcon {...props} src={AlertSVG} />;
export const AddCircleIcon = props => <SvgIcon {...props} src={AddCircleSVG} />;
export const NavigateBeforeIcon = props => <SvgIcon {...props} src={NavigateBeforeSVG} />;
export const NavigateNextIcon = props => <SvgIcon {...props} src={NavigateNextSVG} />;
export const CarouselPrevIcon = props => <SvgIcon {...props} src={CarouselPrevSVG} />;
export const CarouselNextIcon = props => <SvgIcon {...props} src={CarouselNextSVG} />;
export const DeleteIcon = props => <SvgIcon {...props} src={DeleteSVG} />;

export const ListViewIcon = props => <SvgIcon {...props} src={ListViewSVG} />;
export const MapViewIcon = props => <SvgIcon {...props} src={MapViewSVG} />;
export const RedesIcon = props => <SvgIcon {...props} src={RedesSVG} />;
export const DescargarIcon = props => <SvgIcon {...props} src={DescargarSVG} />;
export const ImprimirIcon = props => <SvgIcon {...props} src={ImprimirSVG} />;

export const PromoCodeIcon = props => <SvgIcon {...props} src={PromoCodeSVG} />;
export const LockIcon = props => <SvgIcon {...props} src={LockSVG} />;
export const SecurityIcon = props => <SvgIcon {...props} src={SecuritySVG} />;
export const CreditCardIcon = props => <SvgIcon {...props} src={CreditCardSVG} />;

export const ComodoSSLIcon = props => <SvgIcon {...props} src={ComodoSSLSVG} />;
export const PCIDSSIcon = props => <SvgIcon {...props} src={PCIDSSSVG} />;
export const NightIcon = props => <SvgIcon {...props} src={NightSVG} />;
export const ExitToAppIcon = props => <SvgIcon {...props} src={ExitToAppSVG} />;

export const ArrowBackIcon = props => <SvgIcon {...props} src={ArrowBackSVG} />;
export const ArrowForwardIcon = props => <SvgIcon {...props} src={ArrowForwardSVG} />;
export const ArrowDropDownIcon = props => <SvgIcon {...props} src={ArrowDropDownSVG} />;
export const ArrowDropDownIconNoFill = props => <SvgIcon {...props} src={ArrowDropDownNoFillSVG} />;
export const ArrowRightIcon = props => <SvgIcon {...props} src={ArrowRightSVG} />;
export const ArrowLeftIcon = props => <SvgIcon {...props} src={ArrowLeftSVG} />;
export const GPSNotFixedIcon = props => <SvgIcon {...props} src={GPSNotFixedSVG} />;
export const DateRangeIcon = props => <SvgIcon {...props} src={DateRangeSVG} />;
export const PersonIcon = props => <SvgIcon {...props} src={PersonSVG} />;
export const BabyCarriageIcon = props => <SvgIcon {...props} src={BabyCarriageSVG} />;
export const OccupantsIcon = props => <SvgIcon {...props} src={OccupantsSVG} />;

export const ViewListIcon = props => <SvgIcon {...props} src={ViewListSVG} />;
export const ListIcon = props => <SvgIcon {...props} src={ListSVG} />;
export const MapIcon = props => <SvgIcon {...props} src={MapSVG} />;
export const MarkerMapIcon = props => <SvgIcon {...props} src={MarkerMapSVG} />;
export const MenuIcon = props => <SvgIcon {...props} src={MenuSVG} />;
export const ThumbUpIcon = props => <SvgIcon {...props} src={ThumbUpSVG} />;
export const RubishBinIcon = props => <SvgIcon {...props} src={RubishBinSVG} />;
export const ErrorOutlineIcon = props => <SvgIcon {...props} src={ErrorOutlineSVG} />;
export const WarningIcon = props => <SvgIcon {...props} src={WarningSVG} />;

export const OutlineInfoIcon = props => <SvgIcon {...props} src={OutlineInfoSVG} />;

export const RateIcon = props => <SvgIcon {...props} src={RateSVG} />;
export const Lock2Icon = props => <SvgIcon {...props} src={Lock2SVG} />;

export const GiftIcon = props => <SvgIcon {...props} src={GiftSVG} />;
export const BaselineBarChartIcon = props => <SvgIcon {...props} src={BaselineBarChartSVG} />;

export const MoreVertIcon = props => <SvgIcon {...props} src={MoreVertSVG} />;

export const Close = props => <SvgIcon {...props} src={CloseSVG} />;

export const BuyIcon = props => <SvgIcon {...props} src={BuySVG} />;
